<template>
  <header>
    <div class="top-line">
      <b-row class="logo d-flex align-items-center">
        <b-col xl="3" class="logo-img text-right">
          <div class="img-col">
            <img src="@/assets/images/logo.svg" alt />
          </div>
        </b-col>
        <b-col xl="7" class="logo-text text-left">
          <h1>
            Облачные сервисы для стимулирующих акций
            и программ лояльности
          </h1>
        </b-col>
        <b-col xl="2" class="article-col">
          <Burger></Burger>

          <div class="articles">
            <a href="tel:+78612923572" class="article">
              <img src="@/assets/images/phone.svg" alt />
              <span>+7 (861) 292-35-72</span>
            </a>
            <a href="mailto:info@event-go.ru" class="article">
              <img src="@/assets/images/mail.svg" alt />
              <span class="mail">info@event-go.ru</span>
            </a>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-container>
      <img src="@/assets/images/header-left.png" alt class="header-left-img" />
      <div class="circle"></div>
    </b-container>
  </header>
</template>

<script>
import Burger from "./burger";
export default {
  components: {
    Burger
  }
};
</script>

